"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorCardStatus = exports.sortAlertsBySeverityFunction = exports.isAlertResolved = exports.isAlertActive = exports.ClearedByType = exports.AlertStatus = exports.SensorAlertSeverity = exports.BranchCircuitAlertTypes = exports.OFFLINE_ALERT_TYPES = exports.HUB_OFFLINE_ALERT_TYPES = exports.SENSOR_OFFLINE_ALERT_TYPES = exports.SensorAlertType = void 0;
var SensorAlertType;
(function (SensorAlertType) {
    SensorAlertType["Leak"] = "LEAK";
    SensorAlertType["LowHumidity"] = "LOW_HUMIDITY";
    SensorAlertType["HighHumidity"] = "HIGH_HUMIDITY";
    SensorAlertType["LowMCTCurrent"] = "LOW_MCT_CURRENT";
    SensorAlertType["HighMCTCurrent"] = "HIGH_MCT_CURRENT";
    SensorAlertType["LowBCTCurrent"] = "LOW_BCT_CURRENT";
    SensorAlertType["HighBCTCurrent"] = "HIGH_BCT_CURRENT";
    SensorAlertType["LowVoltage"] = "LOW_VOLTAGE";
    SensorAlertType["HighVoltage"] = "HIGH_VOLTAGE";
    SensorAlertType["LowCurrent"] = "LOW_CURRENT";
    SensorAlertType["HighCurrent"] = "HIGH_CURRENT";
    SensorAlertType["LowPressure"] = "LOW_PRESSURE";
    SensorAlertType["HighPressure"] = "HIGH_PRESSURE";
    SensorAlertType["HVACfilter"] = "HVAC_FILTER";
    SensorAlertType["LowTC"] = "LOW_TC";
    SensorAlertType["HighTC"] = "HIGH_TC";
    SensorAlertType["HighIAQ"] = "HIGH_IAQ";
    SensorAlertType["HighPM"] = "HIGH_PM";
    SensorAlertType["HighVOC"] = "HIGH_VOC";
    SensorAlertType["HighCO2"] = "HIGH_CO2";
    SensorAlertType["LowEC"] = "LOW_EC";
    SensorAlertType["HighEC"] = "HIGH_EC";
    SensorAlertType["LowBattery"] = "LOW_BATTERY";
    SensorAlertType["HvacFilter"] = "HVAC_FILTER";
    SensorAlertType["HvacDegraded"] = "HVAC_DEGRADED";
    // A CT clamp on the condenser/air handler reads no current while the system is
    // demonstrably running. Written by hourlySeerRatingCalculation — the amperage
    // math (Math.max(ct1, ct2) × legs) otherwise masks a single dead leg entirely.
    SensorAlertType["HvacCtFault"] = "HVAC_CT_FAULT";
    SensorAlertType["HvacCompressorFault"] = "HVAC_COMPRESSOR_FAULT";
    // A water quality sensor is REPORTING but the readings are physically
    // impossible (EC <= 0) — a probe fault, not a water condition and not an
    // offline sensor. Deliberately NOT in OFFLINE_ALERT_TYPES: data keeps
    // flowing during the fault, so the data-resumed resolve must not touch it;
    // it condition-ended-resolves when a plausible reading returns.
    SensorAlertType["WqSensorFault"] = "WQ_SENSOR_FAULT";
    // An air-handler monitor is REPORTING but one of its sensors (supply probe,
    // return probe, board SHT40, or supply airflow) returns impossible values.
    // Same lifecycle as WQ_SENSOR_FAULT: UI-only, condition-ended-resolves per
    // channel. Written by sensorEventThresholdHandler.
    SensorAlertType["HvacSensorFault"] = "HVAC_SENSOR_FAULT";
    SensorAlertType["SensorInactive"] = "SENSOR_INACTIVE";
    // Air-quality monitor silence gets its own type: the BME688 is built into
    // the base station, so "check power and range" advice doesn't apply — it
    // signals a hub-side fault (BSEC service / hardware), not a Z-Wave issue.
    SensorAlertType["AqSensorInactive"] = "AQ_SENSOR_INACTIVE";
    // Ambiguous "hub went quiet" — retained for legacy rows and for hubs with no
    // AWS IoT presence history yet. New episodes prefer one of the two causes
    // below, which are genuinely different failures with different fixes.
    SensorAlertType["HubInactive"] = "HUB_INACTIVE";
    // The hub's MQTT session dropped and stayed down: no internet (router/ISP/
    // Wi-Fi) or the base station lost power. Homeowner-fixable.
    SensorAlertType["HubOffline"] = "HUB_OFFLINE";
    // The hub is still connected to AWS but no sensor traffic is coming through
    // it — the Z-Wave side (radio chip or zpc) is dead. Needs a service visit.
    SensorAlertType["HubRadioFault"] = "HUB_RADIO_FAULT";
    SensorAlertType["Unknown"] = "UNKNOWN";
})(SensorAlertType = exports.SensorAlertType || (exports.SensorAlertType = {}));
/** Offline alerts raised against a sensor. */
exports.SENSOR_OFFLINE_ALERT_TYPES = [
    SensorAlertType.SensorInactive,
    SensorAlertType.AqSensorInactive,
];
/**
 * Offline alerts raised against the hub itself. These carry the hub id in
 * `sensorId` (the schema field is non-null), so they never resolve against the
 * sensor list — surfaces must label them with the base station.
 */
exports.HUB_OFFLINE_ALERT_TYPES = [
    SensorAlertType.HubInactive,
    SensorAlertType.HubOffline,
    SensorAlertType.HubRadioFault,
];
/**
 * Every "not reporting" alert type. These auto-resolve when data resumes and
 * are excluded from the backlight ring (a dead sensor would tint the hub
 * indefinitely).
 *
 * They ARE notified. The previous claim here — "never notified by SMS/email" —
 * was wrong: `alertLifecycleNotifier` gates on alertType, not severity, offline
 * types map to `AlertCategory.Connectivity` and do fan out, and
 * `smsNotificationService` has dedicated SENSOR_INACTIVE / AQ_SENSOR_INACTIVE
 * SMS copy. Only the backlight-reset gate is real.
 */
exports.OFFLINE_ALERT_TYPES = [
    ...exports.SENSOR_OFFLINE_ALERT_TYPES,
    ...exports.HUB_OFFLINE_ALERT_TYPES,
];
exports.BranchCircuitAlertTypes = [
    SensorAlertType.LowMCTCurrent,
    SensorAlertType.HighMCTCurrent,
];
var SensorAlertSeverity;
(function (SensorAlertSeverity) {
    SensorAlertSeverity["Critical"] = "critical";
    SensorAlertSeverity["High"] = "high";
    SensorAlertSeverity["Medium"] = "medium";
    SensorAlertSeverity["Low"] = "low";
    SensorAlertSeverity["Info"] = "info";
})(SensorAlertSeverity = exports.SensorAlertSeverity || (exports.SensorAlertSeverity = {}));
var AlertStatus;
(function (AlertStatus) {
    AlertStatus["NEW"] = "new";
    AlertStatus["ONGOING"] = "ongoing";
    AlertStatus["PENDING"] = "pending";
    AlertStatus["ACTIVE"] = "active";
    AlertStatus["ACKNOWLEDGED"] = "acknowledged";
    AlertStatus["RESOLVED"] = "resolved";
    AlertStatus["EXPIRED"] = "expired";
})(AlertStatus = exports.AlertStatus || (exports.AlertStatus = {}));
/**
 * Who resolved an alert:
 *   Hub    — someone tapped Clear on the hub touchscreen (API-key auth, no identity)
 *   User   — a signed-in person; `clearedBy` carries their Cognito sub
 *   System — the backend resolved it (condition ended, service flow, data resumed)
 */
var ClearedByType;
(function (ClearedByType) {
    ClearedByType["Hub"] = "HUB";
    ClearedByType["User"] = "USER";
    ClearedByType["System"] = "SYSTEM";
})(ClearedByType = exports.ClearedByType || (exports.ClearedByType = {}));
/**
 * Single source of truth for "is this alert still active?".
 * Replaces the `(status === 'new' || status === 'ongoing') && !acknowledgedAt`
 * literals that drifted across hooks. PENDING counts as active because the
 * daily re-nag sweep un-clears hidden alerts back to `pending`.
 */
const isAlertActive = (alert) => (alert.status === AlertStatus.NEW ||
    alert.status === AlertStatus.ONGOING ||
    alert.status === AlertStatus.PENDING) &&
    !alert.acknowledgedAt &&
    !alert.clearedAt;
exports.isAlertActive = isAlertActive;
const isAlertResolved = (alert) => !(0, exports.isAlertActive)(alert);
exports.isAlertResolved = isAlertResolved;
/**
 * Sorts sensor alerts by severity, with Critical severity first.
 * @param alerts Array of sensor alerts to sort
 * @returns Sorted array of sensor alerts
 */
const sortAlertsBySeverityFunction = (alertA, alertB) => {
    const severityOrder = {
        [SensorAlertSeverity.Critical]: 0,
        [SensorAlertSeverity.High]: 1,
        [SensorAlertSeverity.Medium]: 2,
        [SensorAlertSeverity.Low]: 3,
        [SensorAlertSeverity.Info]: 4,
    };
    return (severityOrder[alertA.severity] -
        severityOrder[alertB.severity]);
};
exports.sortAlertsBySeverityFunction = sortAlertsBySeverityFunction;
/**
 * The channels a dashboard card / sensor row can be in. Three of them are
 * deliberately distinct and must never be mixed:
 *
 *   Error / Poor  a HAZARD happening now — leak, CT fault, critical filter.
 *                 Red / amber-hazard.
 *   Offline       a COVERAGE GAP — monitoring is impaired, nothing is known to
 *                 be wrong. Neutral surface + coverage-amber accent. Ranks
 *                 BELOW Poor: one dead battery must not paint a category card
 *                 red while every live reading on it is green.
 *   Unknown       no history to report — paired but never reported, or a
 *                 missing fetch result. Gray, lowest non-Good rank.
 *
 * Hub-level offline is NOT in this taxonomy: a dead base station darkens every
 * sensor at once and stays Error (see `alertToCardStatus`).
 */
var SensorCardStatus;
(function (SensorCardStatus) {
    SensorCardStatus["Good"] = "good";
    SensorCardStatus["Poor"] = "poor";
    SensorCardStatus["Error"] = "error";
    SensorCardStatus["Calibrating"] = "calibrating";
    SensorCardStatus["Offline"] = "offline";
    SensorCardStatus["Unknown"] = "unknown";
})(SensorCardStatus = exports.SensorCardStatus || (exports.SensorCardStatus = {}));
